/**
 * This module exports a method which will add support for passing the Options object as
 * a third parameter to addEventListener/removeEventListener. It does not polyfill the
 * behavior of the various settings supported in that object except for the capture option.
 */
let polyfillInitialized = false;

export default function eventListenerPolyfill() {
  if (typeof window === 'undefined' || polyfillInitialized) {
    return;
  }

  polyfillInitialized = true;
  const EventTarget = window.EventTarget || window.Node;
  let supportsOptions = false;
  document.createElement('div').addEventListener('test', function () {}, {
    get passive() {
      supportsOptions = true;
      return false;
    }
  });

  if (!supportsOptions) {
    const originalAddMethod = EventTarget.prototype.addEventListener;
    const originalRemoveMethod = EventTarget.prototype.removeEventListener;

    EventTarget.prototype.addEventListener = function (type, callback, options) {
      const capture = typeof options === 'object' ? options.capture : options;
      originalAddMethod.call(this, type, callback, capture);
    };

    EventTarget.prototype.removeEventListener = function (type, callback, options) {
      const capture = typeof options === 'object' ? options.capture : options;
      originalRemoveMethod.call(this, type, callback, capture);
    };
  }
}
